import { BookGrowList } from "@pdfking/templates/book"
import { BoxGrowList, EnvelopeGrowList } from "@pdfking/templates/box"
import { CoverGrowList } from "@pdfking/templates/cover"
import { FoldGrowList } from "@pdfking/templates/fold"
import { FolderGrowList } from "@pdfking/templates/folder"
import { MiscGrowList } from "@pdfking/templates/misc"
import { RecordMerge } from "@pdfking/tfunc"

/** Every grow the imposition knows, by id: books, boxes, envelopes, covers, folds,
 * the rest, and folders. */
export const GrowList = RecordMerge(
  BookGrowList,
  BoxGrowList,
  EnvelopeGrowList,
  CoverGrowList,
  FoldGrowList,
  MiscGrowList,
  FolderGrowList
)

/** The grows by the list they come from, each list keyed by the label the
 * form titles its group with. */
export const GrowGroups = [
  ["GROW_LIST_COVER", CoverGrowList],
  ["GROW_LIST_BOOK", BookGrowList],
  ["GROW_LIST_BOX", BoxGrowList],
  ["GROW_LIST_ENVELOPE", EnvelopeGrowList],
  ["GROW_LIST_FOLD", FoldGrowList],
  ["GROW_LIST_MISC", MiscGrowList],
  ["GROW_LIST_FOLDER", FolderGrowList],
] as const
